import React from 'react'
import {useAppSelector} from '../../hooks/reduxHooks'
import {Navigate, Outlet} from 'react-router-dom'

const Protector = () => {
	const isAuth = useAppSelector((state) => state.app.isAuth)

	if (!isAuth) {
		return <Navigate to="/login" />
	} else {
		return <Outlet />
	}
}

export default Protector